import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { LocalCustomerFilterComponent } from "../../../general-components/filter/local-customer-filter/local-customer-filter.component";
import { NumAnnoMeseFilterComponent } from "../../../general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component";
import { RegionFilterComponent } from "../../../general-components/filter/region-filter/region-filter.component";
import {
  DeltaVolumiModel,
  DeltaVolumiReportModel,
  DeltaVolumiStorageModel,
} from "../../../../models/DeltaVolumiModel";
import { ContractTypeFilterComponent } from "../../../general-components/filter/contract-type-filter/contract-type-filter.component";
import { Sl1FilterComponent } from "../../../general-components/filter/sl1-filter/sl1-filter.component";
import { LoaderService } from "../../../general-services/service-loader/loader.service";
import { DeltaVolumiService } from "../service-delta-volumi/delta-volumi.service";
import { forkJoin, Observable, Subscription } from "rxjs";
import { Offset } from "src/models/Offset";
import * as toastr from "toastr";
import { ClaimsFilterComponent } from "src/app/general-components/filter/claims-filter/claims-filter.component";
import * as FileSaver from "file-saver";
import { AllSettingsFilterModel } from "../../../../models/AllSettingsFilterModel";
import { RegionService } from "../../../general-services/service-region-anagraf/region-service.service";
import { LocalCustomerAnagrafService } from "../../../general-services/service-local-customer-anagraf/local-customer-anagraf.service";
import { ContractTypeService } from "../../../general-services/service-contract-type/contract-type.service";
import { Sl1AnagrafService } from "../../../general-services/service-sl1-services/sl1-anagraf.service";
import { NumAnnoMeseService } from "../../../general-services/service-num-anno-mese/num-anno-mese.service";
import { MatDialog } from "@angular/material/dialog";
import { GenericArray } from "../../../../models/GenericArray";
import { DialogYearMonthComponent } from "../../../general-components/dialog-year-month/dialog-year-month.component";
import { ResourceUnitFilterComponent } from "../../../general-components/filter/resource-unit-filter/resource-unit-filter.component";
import { ResourceUnitService } from "../../../general-services/service-resources-units-anagraf/resource-unit.service";
import { BaseGeneralComponent } from "../../../BaseGeneralComponent";
import { DeltaFlatFilterComponent } from "src/app/general-components/filter/delta-flat-filter/delta-flat-filter.component";
import { FormControl } from "@angular/forms";
import { DialogSendEmailComponent } from "../../../general-components/dialog-send-email/dialog-send-email.component";
import { ReferenceMonthFilterComponent } from "src/app/general-components/filter/reference-month-filter/reference-month-filter.component";
import { LocationService } from "src/app/general-services/service-location/location.service";
import { ServicesCountryService } from "src/app/general-services/service-services-country/services-country.service";
import { BillingCountryService } from "src/app/general-services/service-billing-country/billing-country.service";
import { urls } from "src/services/api/urls";

@Component({
  selector: "app-filter-delta-volumi",
  templateUrl: "./filter-delta-volumi.component.html",
  styleUrls: ["./filter-delta-volumi.component.scss"],
})
export class FilterDeltaVolumiComponent
  extends BaseGeneralComponent
  implements OnInit, OnDestroy
{
  @Input() numAnnoMeseData?: any;
  @Input() filter?: DeltaVolumiModel;
  @Input() reportSection?: boolean;
  @Input() isComparing?: boolean;

  contractTypeData?: any;
  regionData: any;
  localCustomerData: any;
  designServiceData: any;
  resourceUnitData: any;
  locationData: any;
  srvData: any;
  servicesCountryData: any;
  billingCountryData: any;

  @Output() dataFiltered = new EventEmitter<any>();
  @Output() resetDataFiltered = new EventEmitter<any>();

  @ViewChild(LocalCustomerFilterComponent) localCustomerFilterComponent;
  @ViewChild(ContractTypeFilterComponent, { static: true })
  contractTypeFilterComponent;
  @ViewChild(ReferenceMonthFilterComponent, { static: true })
  referenceMonthFilterComponent;
  @ViewChild(NumAnnoMeseFilterComponent, { static: true })
  numAnnoFilterComponent;
  @ViewChild(RegionFilterComponent, { static: true }) regionFilterComponent;
  @ViewChild(Sl1FilterComponent, { static: true })
  designServicesFilterComponent;
  @ViewChild(DeltaFlatFilterComponent, { static: true })
  deltaFlatFilterComponent;
  @ViewChild(ClaimsFilterComponent, { static: true }) claimsFilterComponent;
  @ViewChild(ResourceUnitFilterComponent, { static: true })
  resourceUnitComponent;

  filterSingle: AllSettingsFilterModel;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;
  labelAnnoMeseRif: string;
  offset: Offset;
  fileName: string;
  intermittentBool: boolean;

  deltaFilter: number;
  shareNameFormControl = new FormControl();

  constructor(
    private loaderService: LoaderService,
    private deltaVolumiService: DeltaVolumiService,
    private numAnnoMeseService: NumAnnoMeseService,
    private regionService: RegionService,
    private localCustomerService: LocalCustomerAnagrafService,
    private contractTypeService: ContractTypeService,
    private sl1AnagrafService: Sl1AnagrafService,
    private resourceUnitService: ResourceUnitService,
    private locationService: LocationService,
    private dialog: MatDialog,
    private servicesCountryService: ServicesCountryService,
    private billingCountryService: BillingCountryService
  ) {
    super();
    this.loaderService.display(true);
  }

  ngOnInit() {
    if (!this.filter) {
      this.filter = new DeltaVolumiModel();
    }
    this.filter.provider = JSON.parse(
      sessionStorage.getItem(
        this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED
      )
    );
    this.filterSingle = AllSettingsFilterModel.getFromDeltaVolumesModel(
      this.filter
    );
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.labelAnnoMeseRif = "Reference Month";
    if (
      JSON.parse(
        sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DELTA_VOLUMES_FILTER)
      )
    ) {
      const filterStorage: DeltaVolumiStorageModel = JSON.parse(
        sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DELTA_VOLUMES_FILTER)
      );
      this.filter = filterStorage;
      this.deltaFilter = filterStorage.deltaFilter;
      this.shareNameFormControl.setValue(this.filter.shareName);
    }

    this.initFilter(this.filterSingle);
  }

  initFilter(
    allSettingsFilterModel: AllSettingsFilterModel,
    isReset?: boolean
  ) {
    this.loaderService.display(true);
    if (this.filter.provider) {
      allSettingsFilterModel.provider = this.filter.provider;
      allSettingsFilterModel.numAnnoMese = this.filter.numAnnoMese;
    }

    const getAllRegionObservable: Observable<any> = this.regionService
      .getListInAllSettings(this.regionService.baseUrl, allSettingsFilterModel)
      .pipe();
    const getAllLocalCustomerObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
          this.localCustomerService.baseUrl,
          allSettingsFilterModel
        ).pipe();
    const getAllContractTypeObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
          this.contractTypeService.baseUrl,
          allSettingsFilterModel
        ).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
          this.sl1AnagrafService.baseUrl,
          allSettingsFilterModel
        ).pipe();
    const getAllResourceunitObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
          this.resourceUnitService.baseUrl,
          allSettingsFilterModel
        ).pipe();
    const getAllLocationObservable: Observable<any> = this.locationService.getListInAllSettings(
          this.locationService.baseUrl,
          allSettingsFilterModel
        ).pipe();
    const getAllSrvObservable: Observable<any> = this.contractTypeService.getSrvInAllSettings(
          urls.contractType, 
          allSettingsFilterModel
        ).pipe();
    const getAllServicesCountryObservable: Observable<any> = this.servicesCountryService.getServicesCountryInAllSettings(
          urls.deltaVolumi, 
          allSettingsFilterModel
        ).pipe();
    const getAllBillingCountryObservable: Observable<any> = this.billingCountryService.getBillingCountryInAllSettings(
          urls.deltaVolumi, 
          allSettingsFilterModel
        ).pipe();

    forkJoin([
      getAllRegionObservable,
      getAllLocalCustomerObservable,
      getAllContractTypeObservable,
      getAllDesignServicesObservable,
      getAllResourceunitObservable,
      getAllLocationObservable,
      getAllSrvObservable,
      getAllServicesCountryObservable,
      getAllBillingCountryObservable
    ]).subscribe(
      (resultFork: any) => {
        this.regionData = resultFork[0];
        this.localCustomerData = resultFork[1];
        this.contractTypeData = resultFork[2];
        this.designServiceData = resultFork[3];
        this.resourceUnitData = resultFork[4];
        this.locationData = resultFork[5];
        this.srvData = resultFork[6];
        this.servicesCountryData = resultFork[7];
        this.billingCountryData = resultFork[8];

        if (!isReset) {
          this.loaderService.display(false);
        } else {
          this.dataFiltered.emit({
            filter: this.filter,
            deltaFilter: this.deltaFilter,
          });
        }
      },
      (error) => {
        console.log(error);
        this.loaderService.display(false);
      }
    );
  }

  interceptRegionChange(event) {
    if(!this.filter.provider.cod.includes("KYN"))
      this.filter.region = event;
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentFilterButton(true);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.region = event;

    const getAllLocalCustomerFilteredObservable: Observable<any> =
      this.localCustomerService
        .getListInAllSettings(
          this.localCustomerService.baseUrl,
          this.filterSingle
        )
        .pipe();
    const getAllContractTypeFilteredObservable: Observable<any> =
      this.contractTypeService
        .getListInAllSettings(
          this.contractTypeService.baseUrl,
          this.filterSingle
        )
        .pipe();
    const getAllDesignServicesObservable: Observable<any> =
      this.sl1AnagrafService
        .getListInAllSettings(this.sl1AnagrafService.baseUrl, this.filterSingle)
        .pipe();

    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllDesignServicesObservable);

    forkJoin(observableList).subscribe(
      (resultFork: any) => {
        this.localCustomerData = resultFork[0];
        this.contractTypeData = resultFork[1];
        this.designServiceData = resultFork[2];

        this.filter.contractType = this.filterSingle.contractType;
        this.filter.localCustomer = this.filterSingle.localCustomer;
        this.filter.designServices = this.filterSingle.sl1;

        this.loaderService.display(false);
      },
      (error) => {
        console.log(error);
        this.loaderService.display(false);
      }
    );
  }

  interceptLocalCustomerChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.localCustomer = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService
      .getListInAllSettings(this.regionService.baseUrl, this.filterSingle)
      .pipe();
    const getAllContractTypeFilteredObservable: Observable<any> =
      this.contractTypeService
        .getListInAllSettings(
          this.contractTypeService.baseUrl,
          this.filterSingle
        )
        .pipe();
    const getAllDesignServicesObservable: Observable<any> =
      this.sl1AnagrafService
        .getListInAllSettings(this.sl1AnagrafService.baseUrl, this.filterSingle)
        .pipe();

    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllDesignServicesObservable);

    forkJoin(observableList).subscribe(
      (resultFork: any) => {
        this.regionData = resultFork[0];
        this.contractTypeData = resultFork[1];
        this.designServiceData = resultFork[2];

        this.filter.region = this.filterSingle.region;
        this.filter.contractType = this.filterSingle.contractType;
        this.filter.designServices = this.filterSingle.sl1;

        this.loaderService.display(false);
      },
      (error) => {
        console.log(error);
        this.loaderService.display(false);
      }
    );
  }

  interceptContractTypeChange(event) {
    if(!this.filter.provider.cod.includes("KYN"))
      this.filter.contractType = event;

    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.contractType = event;

    /** const getAllNumAnnoMeseFilteredObservable: Observable<any> = this.numAnnoMeseService.getAllMonth(
      this.filterSingle.contractType).pipe(); **/
    const getAllRegionFilteredObservable: Observable<any> = this.regionService
      .getListInAllSettings(this.regionService.baseUrl, this.filterSingle)
      .pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> =
      this.localCustomerService
        .getListInAllSettings(
          this.localCustomerService.baseUrl,
          this.filterSingle
        )
        .pipe();
    const getAllDesignServicesObservable: Observable<any> =
      this.sl1AnagrafService
        .getListInAllSettings(this.sl1AnagrafService.baseUrl, this.filterSingle)
        .pipe();

    // observableList.push(getAllNumAnnoMeseFilteredObservable);
    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllDesignServicesObservable);

    forkJoin(observableList).subscribe(
      (resultFork: any) => {
        // this.numAnnoMeseData = resultFork[0];
        this.regionData = resultFork[0];
        this.localCustomerData = resultFork[1];
        this.designServiceData = resultFork[2];

        this.filter.region = this.filterSingle.region;
        this.filter.localCustomer = this.filterSingle.localCustomer;
        this.filter.designServices = this.filterSingle.sl1;

        /** if (!BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
            this.filter.numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
          }**/

        this.loaderService.display(false);
      },
      (error) => {
        console.log(error);
        this.loaderService.display(false);
      }
    );
  }

  interceptSrvChange(value: string) {
    this.filter.srv = value;
    if (!this.reportSection) {
      this.intermittentBool = value !== '' && value !== null;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptServiceCountryChange(value: string) {
    this.filter.servicesCountry = value;
    if (!this.reportSection) {
      this.intermittentBool = value !== '' && value !== null;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptBillingCountryChange(value: string) {
    this.filter.billingCountry = value;
    if (!this.reportSection) {
      this.intermittentBool = value !== '' && value !== null;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }


  interceptDesignServicesChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.sl1 = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService
      .getListInAllSettings(this.regionService.baseUrl, this.filterSingle)
      .pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> =
      this.localCustomerService
        .getListInAllSettings(
          this.localCustomerService.baseUrl,
          this.filterSingle
        )
        .pipe();
    const getAllContractTypeFilteredObservable: Observable<any> =
      this.contractTypeService
        .getListInAllSettings(
          this.contractTypeService.baseUrl,
          this.filterSingle
        )
        .pipe();

    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);

    forkJoin(observableList).subscribe(
      (resultFork: any) => {
        this.regionData = resultFork[0];
        this.localCustomerData = resultFork[1];
        this.contractTypeData = resultFork[2];

        this.filter.region = this.filterSingle.region;
        this.filter.localCustomer = this.filterSingle.localCustomer;
        this.filter.contractType = this.filterSingle.contractType;

        this.loaderService.display(false);
      },
      (error) => {
        console.log(error);
        this.loaderService.display(false);
      }
    );
  }

  interceptNumAnnoMeseChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptNumAnnoMeseFromChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptResourceUnitChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  inteceptIsDeltaSignificativoChange($event) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptDeltaFilterChange($event) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptIsClaimsChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptLocationChange(event) {
    this.filter.location = event;
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  filterTable(): void {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    this.getAllFilters();
    if (!this.reportSection) {
      const filterStorage: DeltaVolumiStorageModel = this
        .filter as DeltaVolumiStorageModel;
      filterStorage.deltaFilter = this.deltaFilter;
      sessionStorage.setItem(
        this.SESSION_STORAGE_LABELS.DELTA_VOLUMES_FILTER,
        JSON.stringify(filterStorage)
      );
    }
    this.dataFiltered.emit({
      filter: this.filter,
      deltaFilter: this.deltaFilter,
      isComparing: this.isComparing,
    });
  }

  reset() {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const isReset = true;
    this.filter = new DeltaVolumiModel();
    this.filter.provider = JSON.parse(
      sessionStorage.getItem(
        this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED
      )
    );
    this.filter.isRecovery = false;
    this.filterSingle = AllSettingsFilterModel.getFromDeltaVolumesModel(
      this.filter
    );
    this.shareNameFormControl.setValue(this.filter.shareName);

    this.deltaFlatFilterComponent.reset();
    this.claimsFilterComponent.reset();
    this.resourceUnitComponent.reset();

    this.filter.numAnnoMeseRif = null;
    if (!this.filter.provider.cod.includes("KYN")) {
      this.filter.contractType = null;
      this.filter.region = null;
    }

    this.filter.resourceUnit = null;

    this.resourceUnitComponent.reset();
    this.filter.location = null;
    this.referenceMonthFilterComponent.reset();

    this.numAnnoMeseService
      .getAllMonth(this.filter.provider, this.filter.contractType)
      .subscribe(
        (resultYearMonth: any) => {
          this.numAnnoMeseData = resultYearMonth;

          const providerDefault = this.filter.provider;
          this.numAnnoMeseData = this.filterFromDxc(
            providerDefault,
            resultYearMonth
          );

          const numAnnoMese = this.numAnnoMeseData[0]
            ? this.numAnnoMeseData[0]
            : null;
          this.filter.numAnnoMese = numAnnoMese;

          this.deltaFilter = null;

          const filterStorage: DeltaVolumiStorageModel = this
            .filter as DeltaVolumiStorageModel;
          filterStorage.deltaFilter = this.deltaFilter;

          sessionStorage.setItem(
            this.SESSION_STORAGE_LABELS.DELTA_VOLUMES_FILTER,
            JSON.stringify(filterStorage)
          );
          this.filterSingle = AllSettingsFilterModel.getFromDeltaVolumesModel(
            this.filter
          );

          this.initFilter(this.filterSingle, isReset);

          this.loaderService.display(false);
        },
        (error) => {
          console.log(error);
          this.loaderService.display(false);
        }
      );
  }

  downloadTableCsv() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.deltaVolumiService
      .getNameGenerateCsv(this.offset, this.filter)
      .subscribe(
        (resultPage) => {
          this.fileName = resultPage.toString();
          this.downloadSubscribe = this.deltaVolumiService
            .getDownloadCsv(this.fileName)
            .subscribe((data) => {
              toastr.success("CSV downloaded with success", "Success");
              this.loaderService.display(false);
              FileSaver.saveAs(
                new Blob([data], { type: "text/csv" }),
                this.fileName
              );
            });
        },
        () => {
          toastr.error(
            "Problem during download CSV, please contact the Administrator",
            "Error"
          );
          this.loaderService.display(false);
        }
      );
  }

  downloadXlsx() {
    this.getAllFilters();
    const reportFilter = this.filter as DeltaVolumiReportModel;
    reportFilter.deltaFilter = this.deltaFilter;
    if (this.reportSection) {
      reportFilter.numAnnoMeseTo = this.numAnnoFilterComponent.optionSelected;
      reportFilter.numAnnoMeseFrom =
        this.numAnnoFilterComponent.optionSelectedFrom;
    } else {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMese;
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMese;
    }
    if (!reportFilter.numAnnoMeseFrom && reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMeseTo;
    } else if (reportFilter.numAnnoMeseFrom && !reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMeseFrom;
    } else {
      console.error("year month filter is missing");
    }

    this.loaderService.display(true);
    this.generateDeltaVolumiXlsx(reportFilter);
  }

  shareXlsx() {
    this.getAllFilters();
    const reportFilter = this.filter as DeltaVolumiReportModel;
    reportFilter.deltaFilter = this.deltaFilter;
    if (this.reportSection) {
      reportFilter.numAnnoMeseTo = this.numAnnoFilterComponent.optionSelected;
      reportFilter.numAnnoMeseFrom =
        this.numAnnoFilterComponent.optionSelectedFrom;
    } else {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMese;
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMese;
    }
    if (!reportFilter.numAnnoMeseFrom && reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMeseTo;
    } else if (reportFilter.numAnnoMeseFrom && !reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMeseFrom;
    } else {
      console.error("year month filter is missing");
    }

    const dialogRef = this.dialog.open(DialogSendEmailComponent, {
      data: {
        currentBaseUrl: this.deltaVolumiService.baseUrl,
        offset: this.offset,
        isComparing: this.isComparing,
        filter: reportFilter,
      },
    });
  }

  generateDeltaVolumiXlsx(reportFilter) {
    let fileName = "Delta Volumes";
    if (this.filter.isRecovery) {
      fileName = "Delta Volumes Balance ";
    } else if (this.isComparing) {
      fileName = "Delta on Preliminary ";
    }
    this.getNameSubscribe = this.deltaVolumiService
      .getNameGenerateXlsx(this.offset, reportFilter, this.isComparing)
      .subscribe(
        (resultPage) => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage], { type: this.EXCEL_TYPE }),
              fileName + " - " + currentDate + ".xlsx"
            );
          } else {
            FileSaver.saveAs(
              new Blob([resultPage], { type: this.EXCEL_TYPE }),
              fileName +
                " - " +
                currentDate +
                " From " +
                reportFilter.numAnnoMeseFrom +
                " To " +
                reportFilter.numAnnoMeseTo +
                ".xlsx"
            );
          }
          toastr.success("XLS downloaded with success", "Success");
          this.loaderService.display(false);
        },
        () => {
          toastr.error(
            "Problem during download XLS, please contact the Administrator",
            "Error"
          );
          this.loaderService.display(false);
        }
      );
  }

  getDate() {
    const date = new Date();
    return (
      date.getFullYear() +
      "-" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getDate()).padStart(2, "0")
    );
  }

  openDialogDownloadXlsx() {
    if (this.reportSection) {
      this.filterTable();
    }
    this.getAllFilters();

    this.offset.deltaFilter = this.deltaFilter;

    const list: GenericArray[] = [
        { id: "filter", value: this.filter },
        { id: "offset", value: this.offset },
        { id: "numAnnoMeseData", value: this.numAnnoMeseData },
        {
          id: "serviceReportPage",
          value: this.SERVICE_REPORT_DOWNLOAD.DELTA_VOLUMI,
        },
        { id: "quotationRequest", value: undefined },
        { id: "comparing", value: this.isComparing },
      ],
      dialogRef = this.dialog.open(DialogYearMonthComponent, {
        data: { list },
      });
    dialogRef.afterClosed().subscribe((result) => {
      // console.log('The dialog was closed');
    });
  }

  getAllFilters() {
    if (!this.reportSection) {
      this.filter.numAnnoMese = this.numAnnoFilterComponent.optionSelected;
      this.filter.numAnnoMeseRif =
        this.referenceMonthFilterComponent.optionSelected;
    }

    this.filter.localCustomer = this.localCustomerFilterComponent
      ? this.localCustomerFilterComponent.getSelectedObject()
      : null;

    this.filter.designServices = this.designServicesFilterComponent.getSelectedObject();
    this.filter.resourceUnit = this.resourceUnitComponent.getSelectedObject();
    this.deltaFilter = this.deltaFlatFilterComponent.optionSelected;
    this.filter.isClaims = this.claimsFilterComponent.claims;
    this.filter.shareName = this.shareNameFormControl.value;
    this.filter.isRecovery = false;
    this.loaderService.display(false);
  }

  isLocalCustomerFilterActive(): boolean {
    if (this.filter && this.filter.provider && this.filter.provider.cod) {
      if (this.filter.provider.cod === "DXC") {
        return false;
      } else {
        return true;
      }
    }
    console.error("no provider found");
    return false;
  }

  ngOnDestroy(): void {}

  getServicesCountry() {
    this.servicesCountryService.getServicesCountryInAllSettings(urls.deltaVolumi, this.filterSingle).subscribe(
      (data) => {
        this.servicesCountryData = data;
      },
      (error) => {
        console.error('Error loading services country:', error);
      }
    );
  }
}
